import { Flex, Text } from "rebass";

const InfoBox = ({ title, children }) => (
  <Flex
    flexDirection="column"
    css={{
      width: "100%",
      background: "#fff",
      border: "2px solid #DDEAF0",
      borderRadius: 6,
      padding: "24px 12px",
      gap: 24,
    }}
  >
    <Text
      color="#212121"
      fontSize={20}
      fontWeight={600}
    >
      {title}
    </Text>
    {children}
  </Flex>
);

export default InfoBox;
